import { useEffect, useState } from "react";
import "./style.scss"
import { substringFun, gclid } from "../../../utils/data/index.js";
import { goWhatsApp } from "../../../utils/data/index";

const Singapore = () => {
    let isTrue = false;
    const [gclId, setGclId] = useState('');
    useEffect(() => {
        const fullUrl = window?.location?.href;
        setGclId(substringFun(fullUrl));
        if (isTrue === false) {
            isTrue = true;
            const scriptDiv1 = document.createElement('script');
            scriptDiv1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16732273568';
            const scriptDiv2 = document.createElement('script');
            scriptDiv2.innerHTML = `
            var _hmt = _hmt || [];
            (function() {
              var hm = document.createElement("script");
              hm.src = "https://hm.baidu.com/hm.js?bcd42900ab5a457f6a491b31d9a6efc8";
              var s = document.getElementsByTagName("script")[0];
              s.parentNode.insertBefore(hm, s);
            })();`;
            const scriptDiv3 = document.createElement('script');
            scriptDiv3.innerHTML = `window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'AW-16732273568');`;
            document.head.appendChild(scriptDiv3);
            document.head.appendChild(scriptDiv1);
            document.head.appendChild(scriptDiv2);
            const noscriptDiv = document.createElement('noscript');
            noscriptDiv.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MH29QND"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            document.body.appendChild(noscriptDiv)
        }
        document.title = 'Online Chinese Tutoring Courses for Singapore - Sinobus';
    }, [])

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'AW-16732273568');
    const gtag_report_conversion = (url) => {
        gclid(gclId);
        var callback = function () {
            console.log("进入回调函数");
            if (typeof (url) != 'undefined') {
                window.open(url, "_blank");
            }
        };
        gtag('event', 'conversion', {
            'send_to': 'AW-16732273568/i2NLCKTGqsYaEKD3yKo-',
            'value': 1.0,
            'currency': 'USD',
            'event_callback': callback()
        });
        return false;
    }
    const goUrl = () => {
        goWhatsApp();
    }
    return <div className="singapore">
        <a className="chatSg">
            <div className="chatSgTxt">即刻搶免費試堂</div>
            <img onClick={() => { goUrl() }} src="../assets/whatsapp.png" alt="" />
        </a>
        <img className="imgDf" src="../assets/sg-page-m2.png" alt="" onClick={() => { goUrl() }} />
        <img className="imgPc" src="../assets/sg-page-pc2.png" alt="" onClick={() => { goUrl() }} />
    </div>
}
export default Singapore;